module.exports = __webpack_public_path__ + "img/Egghead.2a1bdbf7.jpg";